import React from "react";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";

/**
 * Compact row actions: View / PDF / Print / History
 */
const RowActions = ({ onView, onPdf, onPrint, onHistory, className = "" }) => {
  return (
    <div className={`ds-row-actions ${className}`.trim()}>
      {typeof onView === "function" && (
        <button
          type="button"
          className="ds-row-action"
          title="View"
          aria-label="View"
          onClick={(e) => {
            e.stopPropagation();
            onView();
          }}
        >
          <VisibilityOutlinedIcon sx={{ fontSize: 15 }} />
        </button>
      )}
      {typeof onPdf === "function" && (
        <button
          type="button"
          className="ds-row-action"
          title="Download PDF"
          aria-label="Download PDF"
          onClick={(e) => {
            e.stopPropagation();
            onPdf();
          }}
        >
          <PictureAsPdfOutlinedIcon sx={{ fontSize: 15 }} />
        </button>
      )}
      {typeof onPrint === "function" && (
        <button
          type="button"
          className="ds-row-action"
          title="Print"
          aria-label="Print"
          onClick={(e) => {
            e.stopPropagation();
            onPrint();
          }}
        >
          <PrintOutlinedIcon sx={{ fontSize: 15 }} />
        </button>
      )}
      {typeof onHistory === "function" && (
        <button
          type="button"
          className="ds-row-action"
          title="History"
          aria-label="History"
          onClick={(e) => {
            e.stopPropagation();
            onHistory();
          }}
        >
          <HistoryOutlinedIcon sx={{ fontSize: 15 }} />
        </button>
      )}
    </div>
  );
};

export default RowActions;
